import React from "react";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "animate.css";
import "@bsm/component/dist/main.css";
import "@bsm/component/dist/index.css";
import "@bsm/login/dist/main.css";
import "@bsm/login/dist/index.css";
import "@bsm/user-management/dist/main.css";
import "@bsm/project/dist/main.css";
import "@bsm/project/dist/index.css";
// import "@bsm/contract/dist/main.css";
// import "@bsm/payslip/dist/main.css";
import "@bsm/translation/dist/main.css";
import "@bsm/notification/dist/main.css";
import "./index.css";
import { createRoot } from "react-dom/client";

const root = createRoot(document.getElementById("root")!);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
